import { UntitledIcon } from '@faceup/icons'
import { ulCheck } from '@faceup/icons/ulCheck'
import { ulCopy01 } from '@faceup/icons/ulCopy01'
import { Button } from '@faceup/ui-base'
import { useClipboard } from '@mantine/hooks'
import { useContext } from 'react'
import { UiContext } from '../UiProvider/UiProvider'

type CopyButtonProps = {
  value: string
}

export const CopyButton = ({ value }: CopyButtonProps) => {
  const { copy, copied } = useClipboard()
  const { inputCopyable } = useContext(UiContext)
  return (
    <Button
      shape='circle'
      size='small'
      type='text'
      onClick={() => copy(value)}
      label={inputCopyable?.copy ?? 'Copy'}
    >
      <UntitledIcon icon={copied ? ulCheck : ulCopy01} className='text-colorPrimary' />
    </Button>
  )
}
